import { GlobalPositionStrategy, Overlay, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { Component, DestroyRef, effect, inject, ViewEncapsulation } from '@angular/core';
import { LoaderService } from '../loader.service';

@Component({
    selector: 'app-loader-spinner',
    template: '<span class="loader"></span>',
    encapsulation: ViewEncapsulation.None,
    imports: [],
})
export class LoaderSpinnerComponent {}

@Component({
    selector: 'app-loader',
    template: '',
    encapsulation: ViewEncapsulation.None,
    imports: [],
})
export class LoaderComponent {
    private overlayRef: OverlayRef | null = null;
    private loaderService = inject(LoaderService);
    private overlay = inject(Overlay);
    private destroyRef = inject(DestroyRef);

    constructor() {
        effect(() => {
            if (this.loaderService.loading()) {
                this.showSpinner();
            } else {
                this.hideSpinner();
            }
        });

        this.destroyRef.onDestroy(() => this.hideSpinner());
    }

    private showSpinner() {
        if (this.overlayRef) return;

        this.overlayRef = this.overlay.create({
            hasBackdrop: true,
            backdropClass: 'spinner-backdrop',
            positionStrategy: new GlobalPositionStrategy().centerHorizontally().centerVertically(),
        });

        this.overlayRef.attach(new ComponentPortal(LoaderSpinnerComponent));
    }

    private hideSpinner() {
        if (this.overlayRef) {
            this.overlayRef.dispose();
            this.overlayRef = null;
        }
    }
}
